import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import {SeatsNumber} from './styled';
import {CoursePromoContext} from '../context';


const OldPrice = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-decoration: line-through;
  
  color: ${({theme}) => `
    ${transparentize(.2, theme.colors.white)};
  `};
`;

const Price = styled.div`
  font-size: 36px;
  font-weight: 600;
  line-height: 47px;
`;

/**
 * The course promo prices component
 * @return {React.ReactElement}
 * @constructor
 */
export default function Prices(): React.ReactElement {
  const {prices} = React.useContext(CoursePromoContext);

  return (
    <div>
      {
        prices?.old
          ? (
              <OldPrice>
                {prices.old} ₽
              </OldPrice>
            )
          : null
      }
      <Price>
        {prices.current} ₽
      </Price>
      {
        prices?.discountSeats
          ? (
            <SeatsNumber>
              Осталось {prices.discountSeats} мест по этой цене
            </SeatsNumber>
          )
          : null
      }
    </div>
  );
}
